import React from 'react';
import { Button, Modal } from 'react-bootstrap-5';

import PropTypes from 'prop-types';
import { callListUrl } from '../../../helpers/prospect_api';

export default function ImportModalComplete({
  callListId,
  handleClose,
}) {
  return (
    <>
      <Modal.Header closeButton>
        <Modal.Title as="h5">Upload Complete</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <p>
          Your upload has been completed and processed.
          You can begin your outreach on those properties right away.
        </p>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="text-primary" onClick={handleClose}>
          Close
        </Button>
        <Button href={callListUrl(callListId)} variant="secondary">
          View List
        </Button>
      </Modal.Footer>
    </>
  );
}

ImportModalComplete.propTypes = {
  callListId: PropTypes.number.isRequired,
  handleClose: PropTypes.func.isRequired,
};
